export const walletNames = {
    apple: 'Apple Pay',
    google: 'Google Pay',
};
export function isWalletPayment(identifier) {
    return identifier === 'apple_pay' || identifier === 'google_pay';
}
